import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import StoreIcon from "@redotech/redo-icons/building-01.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import {
  AdvancedTableFilter,
  ArrayStringTableFilter,
} from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.stores;

export const SalesChannelFilter = (
  fetcher: (
    { filters }: { filters: AdvancedTableFilter[] },
    signal: AbortSignal,
  ) => Promise<string[]>,
): ArrayStringTableFilter => ({
  type: entry.type,
  itemLabel: "channel",
  operators: [...entry.operators],
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  Icon: StoreIcon,
  valueFetcher: fetcher,
  dbSearch: false,
  displayName: entry.displayName,
  display: (item: string) => {
    try {
      return item.charAt(0).toUpperCase() + item.slice(1);
    } catch (error) {
      return item;
    }
  },
});
